import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const getGlobalMenuApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGlobalMenu: builder.query({
      query: ({
        patientPreferredLang
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = patientPreferredLang;
        return {
          url: `/api/v1/Patient/global-menu`,
          method: "GET",
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetGlobalMenuQuery } = getGlobalMenuApi;
export default getGlobalMenuApi;

